export default __webpack_public_path__ + "static/media/me-framework.edabf234.svg";